module.exports = __webpack_public_path__ + "img/inspirer-of-ideas-2.0bfb6bbd.svg";